// extracted by mini-css-extract-plugin
module.exports = {"container":"Desktop_container__1IVAQ","content":"Desktop_content__vkpBn","calendar":"Desktop_calendar__Zgn7N","count":"Desktop_count__1f5TP"};